export const ROUTE_PATH = {
  LANDING_PAGE: '/',
  WELCOME_PAGE: '/welcome',
  PWA_REDIRECT_PAGE: '/pwa-redirect',
  ONBOARDING: '/onboarding',
  ONBOARDING_SET_PASSWORD: '/onboarding/set-password',
  ONBOARDING_PROFILE: '/onboarding/profile',
  ONBOARDING_PHONE_VERIFICATION: '/onboarding/phone-verification',
  ONBOARDING_TOPIC_PREFERENCES: '/onboarding/topic-preferences',
  SIGNUP: '/signup',
  SIGNUP_GROUP_VERIFICATION: '/signup/group-verification',
  SIGNUP_EMAIL_VERIFICATION: '/signup/email-verification',
  TRUSTED_SIGNUP: '/trusted-signup',
  AUTHENTICATE: '/authenticate',
  ACCEPT_POLICIES: '/accept-policies',
  HOME: '/home',
  PEER_DETAILS: '/peer-details',
  PAYMENT: '/payment',
  TOPIC_PREFERENCES: '/topic-preferences',
  SUPPORT: '/support',
  FAQS: '/faqs',
  LOGIN: '/login',
  ADMIN_REDIRECT: '/admin-redirect',
  BROWSE_TOPIC: '/browse/topic',
  BROWSE_RESOURCES: '/browse/resources',
  BROWSE_STORIES: '/browse/stories',
  BROWSE_PEERS: '/browse/peers',
  BROWSE_PEER_LISTENERS: '/browse/peer-listeners',
  COLLECTION: '/collections',
  PUBLIC_COLLECTION: '/public/collections',
  MY_FAVORITES: '/my-favorites',
  SETTINGS_PROFILE: '/settings/profile',
  SETTINGS_MEMBERSHIP: '/settings/membership',
  SETTINGS_INFO: '/settings/info',
};
